function Toast(txt){
	this.el=$("<p class='toast'>"+txt+"</p>");
	$(".m-toast").append(this.el);
	this.show();
}

Toast.prototype.show=function(){
	var _this=this;
	var width=this.el.outerWidth();
	var height=this.el.outerHeight();
	var windowWidth=$(".g-wrap").width();
	var windowHeith=$(window).height();
	TweenMax.set(this.el,{alpha:0,left:windowWidth/2-width/2,top:windowHeith/2-height/2,marginTop:"0.2rem"});
	TweenMax.to(this.el,0.3,{alpha:1,marginTop:0});
	TweenMax.to(this.el,0.3,{alpha:0,delay:1.7,marginTop:"-0.2rem",onComplete:function(){
		_this.destroy();
	}});
}

Toast.prototype.destroy=function(){
	TweenMax.killTweensOf(this.el);
	this.el.remove();
	this.el=null;
}

module.exports=Toast;




//////////////////
// WEBPACK FOOTER
// ./pages/yubashuo/js/toast.js
// module id = 1
// module chunks = 0 2